import { jsx } from "react/jsx-runtime";
import assert from "assert";
import { useContext } from "react";
import { Box } from "../Box/Box.mjs";
import { Divider } from "../Divider/Divider.mjs";
import { MenuRendererContext } from "../MenuRenderer/MenuRendererContext.mjs";
const MenuItemDivider = () => {
  assert(
    useContext(MenuRendererContext),
    "MenuItemDivider must be rendered within a menu component. See the documentation for correct usage: https://seek-oss.github.io/braid-design-system/components/MenuItemDivider"
  );
  return /* @__PURE__ */ jsx(Box, { paddingY: "xxsmall", children: /* @__PURE__ */ jsx(Divider, {}) });
};
MenuItemDivider.__isMenuItem__ = true;
export {
  MenuItemDivider
};
